__webpack_require__.p = "/posventa/";